import { useState } from 'react';
import styles from './foldable-cards.module.scss';
import { IoIosArrowDropdownCircle, IoMdCloseCircle } from 'react-icons/io';
import Constants from '../../constants';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import { pdfImgSrc, pdfSrc, universityImgSrc } from '../../data';
import { Document, Page } from 'react-pdf';
import pdfIcon from '../../images/file.svg';
import alphaIcon from '../../images/alpha-black.svg';
import omegaIcon from '../../images/omega-black.svg';

const FoldableCards = ({ type, payload }) => {
  return (
    <main className={styles.foldableCard}>
      <Accordion>
        <AccordionSummary
          expandIcon={<IoIosArrowDropdownCircle className={styles.openIcn} />}
          aria-controls='panel1a-content'
          id='panel1a-header'
        >
          <Typography className={styles.heading}>
            <h3>{type}</h3>
          </Typography>
        </AccordionSummary>
        <AccordionDetails className={styles.cardOpened}>
          {payload.map((item) => {
            if (type === Constants.ADMITTED_UNIVERSITIES) {
              return (
                <img
                  className={styles.universityImg}
                  key={item}
                  src={universityImgSrc[item]}
                />
              );
            }
            if (type === Constants.STATEMENT_OF_PURPOSE) {
              return (
                <article className={styles.pdfThumbnail}>
                  <img className={styles.pdfImg} src={item.imgUrl} />
                  <section className={styles.pdfDetails}>
                    <p>{item.name}</p>
                    <img className={styles.pdfIcon} src={pdfIcon} />
                  </section>
                </article>
              );
            }
            if (type === Constants.LETTER_OF_RECOMMENDATIONS) {
              return (
                <article className={styles.pdfThumbnail}>
                  <img className={styles.pdfImg} src={item.imgUrl} />
                  <section className={styles.pdfDetails}>
                    <p>{item.name}</p>
                    <img className={styles.pdfIcon} src={pdfIcon} />
                  </section>
                </article>
              );
            }
            if (type === Constants.PENDING_REQUESTS) {
              return (
                <article className={styles.pendingRequest}>
                  <img className={styles.profileImg} src={item.imgUrl} />
                  <IoMdCloseCircle className={styles.closeIcn} />
                  <section className={styles.profileDetails}>
                    <h4>
                      {item.firstName} {item.lastName}
                      {/* TO DO - A better way to display alpha/omega icon {item.type === Constants.USER_TYPE_ALPHA && (
                        <img className={styles.alphaIcn} src={alphaIcon} />
                      )}
                      {item.type === Constants.USER_TYPE_OMEGA && (
                        <img className={styles.omegaIcn} src={omegaIcon} />
                      )} */}
                    </h4>
                  </section>
                  <button className={`greenButton ${styles.acceptButton}`}>
                    Accept
                  </button>
                </article>
              );
            }
          })}
        </AccordionDetails>
      </Accordion>
    </main>
  );
};

export default FoldableCards;
